module.exports = __webpack_public_path__ + "static/media/logo_dark.d1c8412b.png";